<template>
  <div class="web-body" v-if="urlPath == 'blog'">
    <blog/>
  </div>
  <div class="web-body" v-else-if="urlPath == 'policy'">
    <policy/>
  </div>
  <div class="web-body" v-else>
    <div v-if="urlPath == ''">
      <slide/>
    </div>
    <div v-html="body"/>
  </div>
</template>


<script>
import axios from 'axios';
import blog from './Blog.vue';
import slide from "./Slide.vue";
import policy from './Policy.vue';
export default {
  name: 'web-body',
  components: {
    blog,
    policy,
    slide
  },
  data () {
    return {
      productStoreId: null,
      wikiSpaceId: null,
      pagePath: null,
      urlPath: null,
      body: null
    }
  },
  mounted() {
    if (this.$route.query.lang) {
      this.$cookie.set('language', this.$route.query.lang, 1);
    }
    if (this.$cookie.get('language') != 'undefined') {
      this.$language = this.$cookie.get('language')
    }
    if (this.$language == 'en') { this.$language = this.$language+'_US' }
    if (this.$language == 'th') { this.$language = this.$language+'_TH' }
    this.urlPath = this.$route.path.replace("/", "");
    if(this.urlPath != 'blog'){
      this.$backendService.getStoreContentInfo(this.$productStoreId, this.$language).then (dataInfo => {
        if (this.urlPath == "") {
          this.templateWikiSpaceId = dataInfo.data.templateWikiSpaceId;
          this.pagePath = dataInfo.data.wikiTemplateInfo.template_client_content;
        } else {
          dataInfo.data.webSiteContentList.forEach(webSiteContent => {
            if (this.urlPath == webSiteContent.aliasPath) {
              this.templateWikiSpaceId = dataInfo.data.contentWikiSpaceId;
              this.pagePath = webSiteContent.aliasPath;
            }
          })
        }
        this.productStoreId = dataInfo.data.productStore.productStoreId;
        this.$backendService.getContentHTML(this.productStoreId, this.templateWikiSpaceId, this.pagePath).then (result => {
          this.body = result.data.contentText;
            (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0],
            t = window.twttr || {};
            if (d.getElementById(id)) return t.widgets.load();
            js = d.createElement(s);
            js.id = id;
            js.src = "https://platform.twitter.com/widgets.js";
            fjs.parentNode.insertBefore(js, fjs);

            t._e = [];
            t.ready = function (f) {
            t._e.push(f);
            };
            return t;
            }(document, "script", "twitter-wjs"));
        })
      })
    }

  }
}
</script>




// WEBPACK FOOTER //
// src/components/Body.vue